(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["testimonials-carousel"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('reviews-carousel')) {
  customElements.define('reviews-carousel', class ReviewsCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-review-track]');
      this.cards = this.querySelector('[data-review-cards]');
      if (!this.track || !this.cards) return;

      this.previousButton = this.querySelector('[data-review-previous]');
      this.nextButton = this.querySelector('[data-review-next]');
      this.controls = this.querySelector('[data-review-controls]');
      this.progress = this.querySelector('[data-review-progress]');
      this.thumb = this.querySelector('[data-review-thumb]');
      this.abortController = new AbortController();
      const { signal } = this.abortController;

      this.track.addEventListener('scroll', () => this.scheduleUpdate(), { passive: true, signal });
      this.track.addEventListener('keydown', (event) => this.onKeydown(event), { signal });
      this.previousButton?.addEventListener('click', () => this.move(-1), { signal });
      this.nextButton?.addEventListener('click', () => this.move(1), { signal });
      this.addEventListener('shopify:block:select', (event) => this.selectCard(event.target), { signal });

      this.resizeObserver = new ResizeObserver(() => this.scheduleUpdate());
      this.resizeObserver.observe(this.track);
      this.resizeObserver.observe(this.cards);
      this.update();
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.frame);
      this.frame = null;
    }

    get direction() {
      return getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
    }

    get maxScroll() {
      return Math.max(0, this.track.scrollWidth - this.track.clientWidth);
    }

    get position() {
      return Math.min(this.maxScroll, Math.max(0, this.track.scrollLeft * this.direction));
    }

    scheduleUpdate() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        this.update();
      });
    }

    update() {
      const maxScroll = this.maxScroll;
      const position = this.position;
      const scrollable = maxScroll > 1;

      if (this.controls) this.controls.hidden = !scrollable;
      if (this.previousButton) this.previousButton.disabled = !scrollable || position <= 2;
      if (this.nextButton) this.nextButton.disabled = !scrollable || position >= maxScroll - 2;
      if (scrollable) this.track.setAttribute('tabindex', '0');
      else this.track.removeAttribute('tabindex');

      if (this.progress && this.thumb) {
        this.progress.hidden = !scrollable;
        const visible = this.track.clientWidth / this.track.scrollWidth;
        const offset = scrollable ? position / maxScroll * (1 - visible) : 0;
        this.thumb.style.width = `${visible * 100}%`;
        this.thumb.style.insetInlineStart = `${offset * 100}%`;
      }
    }

    scrollToPosition(position) {
      this.track.scrollTo({
        left: Math.min(this.maxScroll, Math.max(0, position)) * this.direction,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
      });
    }

    move(step) {
      const cards = this.cards.children;
      if (cards.length < 2) return;
      const distance = Math.abs(cards[1].getBoundingClientRect().left - cards[0].getBoundingClientRect().left);
      this.scrollToPosition(this.position + distance * step);
    }

    onKeydown(event) {
      if (event.target !== this.track || event.altKey || event.ctrlKey || event.metaKey) return;
      switch (event.key) {
        case 'ArrowLeft':
          event.preventDefault();
          this.move(-this.direction);
          break;
        case 'ArrowRight':
          event.preventDefault();
          this.move(this.direction);
          break;
        case 'Home':
          event.preventDefault();
          this.scrollToPosition(0);
          break;
        case 'End':
          event.preventDefault();
          this.scrollToPosition(this.maxScroll);
          break;
      }
    }

    selectCard(target) {
      const card = target.closest('[data-review-card]');
      if (!card || !this.cards.contains(card)) return;
      const cardRect = card.getBoundingClientRect();
      const trackRect = this.track.getBoundingClientRect();
      const offset = this.direction === 1 ? cardRect.left - trackRect.left : trackRect.right - cardRect.right;
      this.scrollToPosition(this.position + offset);
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
